import { BillLineItemV2Kind, BillLineCashinV2 } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemCashinPaymentMock = new MockFactory<BillLineCashinV2>({
  id: 'cashin_payment_id_1',
  amount_cents: 2002,
  reference_date: '2022-04-10T00:00:00Z',
  payer_id: 'payer_id_01',
  kind: BillLineItemV2Kind.CashinPayment,
  metadata: {
    cashin_id: 'cashin_id_1',
    amount_cents: 20000,
    created_at: '2022-04-10T00:00:00Z',
  },
})
